import {useAppNotificationContext} from '../../services/notification/AppNotificationProvider';

export const useOpenNotification = () => {
  const {openInfoNotification, openErrorNotification, openSuccessNotification} =
    useAppNotificationContext();

  return {openInfoNotification, openErrorNotification, openSuccessNotification};
};
